import { render } from "./np-vat.vue?vue&type=template&id=78670bfd"
import script from "./np-vat.vue?vue&type=script&lang=js"
export * from "./np-vat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__